import React from 'react';
import { reduxForm } from 'redux-form/immutable';

// components
import { Link } from 'react-router';

// images
import successImage from '../../../assets/images/success';

const Success = function() {
  return (
    <div className='manager-new__step1'>
      <img className='manager-new__step4__success' src={ successImage } />
      <p className='manager-new__step4__description'>
        Awesome! Let's get started!
      </p>
      <div className='form__submit'>
        <Link className='form__button form__button--green'
          to='/managers/calendar'>
          Let's go!
        </Link>
      </div>
    </div>
  );
};

export default (
  reduxForm(
    {
      form: 'managerNew'
    }
  )(Success)
);



// WEBPACK FOOTER //
// ./app/components/managers/signUp/_Success.jsx